import dynamic from 'next/dynamic';
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import SkeletonLoader from './SkeletonLoader';
import { GameList } from "../list/GameList";
import { viewMoreUrls } from "../list/viewMoreUrls";

const HorizontalScroll = dynamic(() => import('./HorizontalScroll'), {
  loading: () => <SkeletonLoader/>,
});
const Ad_320x50 = dynamic(() => import('../ads/Ad_320x50'), {  });
const Ad_728x90_Bot = dynamic(() => import('../ads/Ad_728x90_Bot'), {  });

export default function Game_Components({ gamesData }) {

  const path = useRouter();
  const [mobile, setMobile] = useState(false);

  
  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    setMobile(isMobile);
  }, []);
  

// *************************************************************


const getGamesByTag = (tag) => {
  try {
    if (!GameList || !Array.isArray(GameList)) {
      console.error('GameList is undefined or not an array');
      return [];
    }

    const filteredGames = GameList.filter(game => game.tag.includes(tag));

    // while (filteredGames.length < 10) {
    //   filteredGames.push(...filteredGames.slice(0, 10 - filteredGames.length));
    // }

    return filteredGames.slice(0, 30);
    // return filteredGames;
  } catch (error) {
    console.error('Error filtering games:', error);
    return [];
  }
};

  return (
    <>
    <HorizontalScroll games={(gamesData?.newGames || [])} category="New Games" viewMoreUrl={viewMoreUrls['New Games']} layoutType={"double"}  />
    {path.pathname =="/"&&<HorizontalScroll games={(gamesData?.exclusiveGames || [])} category="Recommended Games" viewMoreUrl={viewMoreUrls['Exclusive']} layoutType={"single"} showhot={'yes'}/>}
    {mobile && <Ad_320x50 />} 
    {!mobile && <Ad_728x90_Bot />} 
    <HorizontalScroll games={(gamesData?.racingGames || [])} category="Racing Games" viewMoreUrl={viewMoreUrls['Racing']} layoutType={"single"}/>
    <HorizontalScroll games={(gamesData?.fightingGames || [])} category="Fighting Games" viewMoreUrl={viewMoreUrls['Fighting']} layoutType={"single"}/>
    <HorizontalScroll games={(gamesData?.puzzleGames || [])} category="Puzzle Games" viewMoreUrl={viewMoreUrls['Puzzle']} layoutType={"single"}/>
    {mobile && <Ad_320x50 />} 
    {!mobile && <Ad_728x90_Bot />} 
    <HorizontalScroll games={(gamesData?.ioGames || [])} category="Io Games" viewMoreUrl={viewMoreUrls['Io Games']} layoutType={"single"}/>
    <HorizontalScroll games={(gamesData?.shootingGames || [])} category="Shooting Games" viewMoreUrl={viewMoreUrls['Shooting Games']} layoutType={"single"} />
    <HorizontalScroll games={(gamesData?.girlGames || [])} category="Girl Games" viewMoreUrl={viewMoreUrls['Puzzle']} layoutType={"single"}/>
    <HorizontalScroll games={(gamesData?.actionGames || [])} category="Action Games" viewMoreUrl={viewMoreUrls['Action']} layoutType={"single"}/>
    </>
  );
}
